import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { ListingSortKlevuEngine } from '@df/module-klevu-search/listing-sort-klevu.engine';
import { SearchService } from '@df/search/search.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModuleKlevuSearch } from './klevu-search.namespace';
import { KlevuTrackClickDirective } from './klevu-track-click.directive';
import { KlevuTrackService } from './klevu-track.service';

@NgModule({
    imports: [KlevuTrackClickDirective],
    exports: [KlevuTrackClickDirective]
})
export class KlevuSearchModule {
    static forRoot(config?: DeepPartial<NDfModuleKlevuSearch.IModuleOptions>): ModuleWithProviders<KlevuSearchModule> {
        return {
            ngModule: KlevuSearchModule,
            providers: [
                { provide: SearchService, useExisting: KlevuSearchService },
                {
                    provide: NDfModuleKlevuSearch.OPTIONS,
                    useFactory: () => defaultsDeep(config, NDfModuleKlevuSearch.DEFAULT_OPTIONS)
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: (listingSortKlevuEngine: ListingSortKlevuEngine) => () => {
                        ListingSort.engines['klevu'] = listingSortKlevuEngine;
                    },
                    deps: [ListingSortKlevuEngine],
                    multi: true
                }
            ]
        };
    }
    
    // needed here to initialize early
    constructor(klevuTrackService: KlevuTrackService) {
        klevuTrackService.appInitialize();
    }
}
